<template>
    <MainContent title="Listado de acreditaciones">
        <template v-slot:header>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-lg-10">
                        <label>Seleccionar evento</label>
                        <multiselect
                            v-model="evento"
                            :options="eventos"
                            placeholder="Seleccionar evento"
                            label="name"
                            track-by="id"
                            :close-on-select="true"
                            v-on:select="debouncedGetAcreditaciones"
                            v-on:remove="onRemove"
                        >
                            <template slot="noResult">No existe ese evento.</template>
                        </multiselect>
                    </div>
                    <div class="col-12 col-lg-2 d-flex align-items-end mt-3 mt-lg-0">
                        <div class="checkbox-container d-flex">
                            <div class="form-check form-check-inline">
                                <input type="checkbox" id="actuales" v-model="actuales" @change="handleCheckboxClick($event, 'actuales')" />
                                <label for="actuales">Actuales</label>
                            </div>

                            <div class="form-check form-check-inline">
                                <input type="checkbox" id="pasados" v-model="pasados" @change="handleCheckboxClick($event, 'pasados')" />
                                <label for="pasados">Pasados</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:content >
            <div>
                <div v-if="acreditaciones">
                    <div class="card-header pt-0">
                        <div class="row align-items-center mb-4">
                            <div class="col-12 col-lg-8 mb-3 mb-lg-0">
                                <div class="form-group">
                                    <SearchComponent  big="true" v-model="filters.search" @input="debouncedGetAcreditaciones" />
                                </div>
                            </div>
                            <div class="col-12 col-lg-4 text-lg-right d-flex justify-content-end">
                                <div class="btn-group">
                                    <a
                                        :href="url_imprimir_todas()"
                                        class="btn btn-primary mb-3 mr-2"
                                        target="_blank"
                                    >
                                        Descargar Acreditaciones
                                    </a>
                                    <router-link
                                        :to="{ name: 'back.acreditaciones.crear', params: { evento_id: evento.id } }"
                                        class="btn btn-primary mb-3"
                                        target="blank"
                                    >
                                        Nueva acreditación
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ContentOrLoading>
                    <div class="card-body" v-if="!loading">
                        <div :class="['table', { 'expanded': acreditaciones.data.length <= 3 }]" v-if="acreditaciones !== null">
                            <b-table hover :items="acreditaciones.data" :fields="fields" id="acreditaciones-table" >
                                <template #cell(puertas)="{ item }">
                                    {{ item.puertasSelect.map(i => i.nombre).join(', ') }}
                                </template>
                                <template #cell(opciones)="{ item, index }">
                                    <OpcionesDropdownTableComponent
                                        :lastIndex="acreditaciones.data.length > 3 && index >= acreditaciones.data.length - 3"
                                        v-bind:options="[
                                            { to: { name: 'back.acreditaciones.show', params: { evento_id: evento.id, acreditacion_id: item.id }}, label: 'Ver'},
                                            ...item.estado === 1 ? [{ to: { name: 'back.acreditaciones.update', params: { evento_id: evento.id, acreditacion_id: item.id }}, label: 'Editar' }] : [],
                                            ...item.estado === 0 || item.estado === 2 ? [{ to: { name: 'back.acreditaciones.activar', params: { evento_id: evento.id, acreditacion_id: item.id }}, label: 'Activar' }] : [],
                                            ...item.estado === 0 || item.estado === 1 ? [{ type: 'action', action: () => showModal('cancelar-' + item.id, item), label: 'Cancelar' }] : [],
                                            { type: 'action', action: () => showModal('borrar-' + item.id, item), label: 'Borrar' },
                                            ...item.estado === 1 ? [{ type: 'url', url: config.API_BASE + item.url_imprimir + '&tid=' + configuracion.hash_teatro, label: 'Imprimir acreditación' }] : [],
                                        ]"
                                    />
                                    <BorrarModalComponent
                                        :name="'borrar-' + item.id"
                                        :title="'Borrar acreditación ' + item.nombre"
                                        confirmButton="¿Está segur@ de borrar esta acreditación?"
                                        v-on:close="() => closeModal('borrar-' + item.id)"
                                        v-on:confirm="() => borrarAcreditacion(item.id)"
                                    />
                                    <ModalAcreditaciones
                                        :name="'cancelar-' + item.id"
                                        :title="'Cancelar acreditación ' + item.nombre"
                                        confirmButton="¿Está segur@ de cancelar esta acreditación?"
                                        buttom="CANCELAR ACREDITACIÓN"
                                        @close="closeModal('cancelar-' + item.id)"
                                        @confirm="cancelarAcreditacion"
                                    />
                                </template>
                            </b-table>
                        </div>
                        <div class="row justify-content-between" v-if="acreditaciones">
                            <div class="col-12 col-lg-3">
                                <ElementosPorPaginaComponent v-model="filters.per_page" @change="debouncedGetAcreditaciones"/>
                            </div>
                            <div class="col-12 col-lg-4" v-if="eventos">
                                <PaginateComponent
                                    :current_page="acreditaciones.meta.current_page"
                                    :last_page="acreditaciones.meta.last_page"
                                    v-on:change_page="setPage"
                                />
                            </div>
                        </div>
                    </div>
                </ContentOrLoading>
            </div>
        </template>
    </MainContent>
</template>



<script>
    import MainContent from "../../../components/backend/components/MainContent";
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"
    import ModalAcreditaciones from "@/components/backend/acreditaciones/ModalAcreditaciones"

    export default {
        data() {
            return {
                acreditaciones: null,
                loading: false,
                fields: [
                    { key: "nombre", label: "Nombre" },
                    { key: "medio", label: "Medio" },
                    { key: "funcion", label: "Función" },
                    { key: "dni", label: "DNI" },
                    { key: "email", label:"Email" },
                    { key: "telefono", label: "Teléfono" },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                },
                acreditacion: {},
                eventos: [],
                evento: null,
                actuales: true,
                pasados: false,
            }
        },
        created() {
            this.getEvents();
            this.debouncedGetAcreditaciones = _.debounce(this.updateURL, 500);
        },
        methods: {
            onRemove(removed) {
                this.acreditaciones = null
                this.evento = null;
            },
            updateURL() {
                const query = {
                    per_page: this.filters.per_page,
                    page: this.filters.page,
                };

                if (this.evento && this.evento.id) {
                    query.evento_id = this.evento.id;
                }

                if (this.filters.search !== '') {
                    query.search = this.filters.search;
                }

                this.$router.push({ path: '/admin/acreditaciones', query: query }).finally(() => this.getAcreditaciones());
            },
            searchParams() {
                const params = {
                    filters: {
                        per_page: this.filters.per_page,
                        page: this.filters.page,
                    }
                };

                if (this.evento && this.evento.id) {
                    params.evento_id = this.evento.id;
                }

                if (this.filters.search !== "") {
                    params.filters.search = this.filters.search;
                }

                return params;
            },
            getAcreditaciones() {
                if (!this.evento) return;

                this.loading = true;
                const params = {
                    filters: this.filters,
                    evento_id: this.evento.id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.index'), params)
                    .then(res => {
                        this.acreditaciones = res.data;
                    })
                    .finally(() => this.loading = false);
            },
            getEvents() {
                this.loading = true;

                const data = {
                    filters: {
                        to_select: true,
                    }
                };

                if(this.actuales && !this.pasados) {
                    data.filters.e = 'actuales';
                } else if(!this.actuales && this.pasados) {
                    data.filters.e = 'pasados';
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.eventos = res.data.data;

                    if (this.$route.query.evento_id) {
                        this.evento = this.eventos.find(event => event.id == this.$route.query.evento_id);
                    }

                    if (this.evento) {
                        this.getAcreditaciones();
                    }

                }).finally(() => this.loading = false);
            },
            borrarAcreditacion(acreditacion_id) {
                const params = {
                    filters : {},
                    evento_id: this.evento.id,
                    acreditacion_id: acreditacion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getAcreditaciones();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
                this.closeModal('borrar-' + acreditacion_id);
            },
            cancelarAcreditacion(mensaje) {
                const params = {
                    filters : {},
                    evento_id: this.evento.id,
                    acreditacion_id: this.acreditacion.id,
                    cancelar: true,
                    mensaje: mensaje
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.activar-cancelar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getAcreditaciones();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
                this.closeModal('cancelar-' + this.acreditacion_id);
            },
            setPage(page) {
                this.filters.page = page;
                this.getAcreditaciones();
            },
            showModal(modal, acreditacion) {
                this.acreditacion = acreditacion;
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            url_imprimir_todas() {
                const params = this.searchParams().filters;
                delete(params.per_page);
                delete(params.page);
                const query = new URLSearchParams(params);

                return this.config.API_BASE + '/eventos/' + this.evento.id + '/acreditaciones/imprimir?api_key=' + localStorage.getItem('token') + "&" + query + '&tid=' + this.configuracion.hash_teatro;
            },
            handleCheckboxClick(event, checkbox) {
                if(!this.actuales && !this.pasados){
                    this.$nextTick(() => {
                        this[checkbox] = true;
                    });
                    event.preventDefault();
                    this.$toast.warning('Debe mantener al menos un filtro seleccionado');
                    return;
                }

                const query = Object.assign({}, this.$route.query);
                if (query.evento_id) {
                    delete query.evento_id;
                    this.$router.replace({ path: this.$route.path, query }).finally(() => {
                        this.evento = null;
                        this.acreditaciones = null;
                        this.getEvents();
                    });
                } else {
                    this.getEvents();
                }
            },
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        components: {
            SearchComponent,PaginateComponent,ElementosPorPaginaComponent,OpcionesDropdownTableComponent, BorrarModalComponent, ModalAcreditaciones, MainContent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>
